import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import './Navbar.css';

function Navbar() {
  const location = useLocation();
  const path = location.pathname;
  const { isDark, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">

      {/* LOGO */}
      <Link to="/" className="nav-logo" onClick={closeMenu}>
        <img
          src="/monogram.svg"
          alt="The Atharva Veda Equity"
          className="nav-monogram"
        />
        <div className="nav-logo-text">
          <span className="nav-brand">The Atharva Veda Equity</span>
          <span className="nav-brand-sub">Stock Market Institute</span>
        </div>
      </Link>

      {/* DESKTOP LINKS */}
      <div className="nav-links">
        <Link to="/" className={`nav-link ${path === '/' ? 'active' : ''}`}>Home</Link>
        <Link to="/about" className={`nav-link ${path === '/about' ? 'active' : ''}`}>About</Link>
        <Link to="/courses" className={`nav-link ${path === '/courses' ? 'active' : ''}`}>Courses</Link>
        <Link to="/contact" className={`nav-link ${path === '/contact' ? 'active' : ''}`}>Contact Us</Link>
      </div>

      {/* DESKTOP RIGHT — theme toggle + CTA */}
      <div className="nav-right">
        <button
          className="nav-theme-toggle"
          onClick={toggleTheme}
          title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          aria-label="Toggle theme"
        >
          {isDark ? (
            /* SUN */
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          ) : (
            /* MOON */
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          )}
        </button>

        <Link to="/enquiry" className="nav-cta">Join Now</Link>
      </div>

      {/* MOBILE RIGHT — theme toggle + hamburger */}
      <div className="nav-mobile-right">
        <button
          className="nav-theme-toggle"
          onClick={toggleTheme}
          aria-label="Toggle theme"
        >
          {isDark ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          ) : (
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          )}
        </button>

        <button
          className={`nav-hamburger ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* MOBILE MENU */}
      <div className={`nav-mobile-menu ${menuOpen ? 'open' : ''}`}>
        <Link to="/" className={`nav-mobile-link ${path === '/' ? 'active' : ''}`} onClick={closeMenu}>Home</Link>
        <Link to="/about" className={`nav-mobile-link ${path === '/about' ? 'active' : ''}`} onClick={closeMenu}>About</Link>
        <Link to="/courses" className={`nav-mobile-link ${path === '/courses' ? 'active' : ''}`} onClick={closeMenu}>Courses</Link>
        <Link to="/contact" className={`nav-mobile-link ${path === '/contact' ? 'active' : ''}`} onClick={closeMenu}>Contact Us</Link>
        <Link to="/enquiry" className="nav-mobile-cta" onClick={closeMenu}>Join Now</Link>
      </div>

    </nav>
  );
}

export default Navbar;